module.exports = __webpack_public_path__ + "static/img/freezer_sa.4be4e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_sa.jpg
// module id = DCtr
// module chunks = 1